// API base configuration:
// - Local dev: Django on localhost:8000
// - Staging/production: same browser origin, with Nginx proxying /api/ to Django

const browserLocation = typeof window !== "undefined" ? window.location : null;
const hostname = browserLocation?.hostname || "";

const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
const runtimeOrigin = browserLocation?.origin || "";

let API_BASE;
let BACKEND_BASE;

if (isLocalhost) {
  const localBackendOrigin = `http://${hostname}:8000`;
  API_BASE = `${localBackendOrigin}/api/`;
  BACKEND_BASE = `${localBackendOrigin}/`;
} else {
  API_BASE = `${runtimeOrigin}/api/`;
  BACKEND_BASE = `${runtimeOrigin}/`;
}

export { API_BASE, BACKEND_BASE };
